import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=01dfd0f2&scoped=true&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./contact.vue?vue&type=style&index=0&id=01dfd0f2&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "01dfd0f2",
  "67c2348a"
  
)

export default component.exports